<template>
    <MainViewFrame>
        <ScratchAllWorks />
    </MainViewFrame>
</template>

<script>
import MainViewFrame from "../../MainViewFrame.vue";
import ScratchAllWorks from './ScratchAllWorks.vue'

export default {
  name: "ScratchAllWorksContainer",
  components: {
    MainViewFrame,
    ScratchAllWorks
  }
};
</script>

<style lang="less" scoped>
  
</style>